import { create } from 'apisauce';

const api = create({
  // eslint-disable-next-line no-undef
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    Authorization: '',
  },
});

export default api;
